// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import "@rails/actiontext"
import "chartkick/chart.js"
import "@37signals/lexxy"

// Disabling Form Buttons
Turbo.config.forms.submitter = "aria-disabled"

// Lazy load chartkick only on pages that need it
document.addEventListener("turbo:load", () => {
  if (document.querySelector("#chart-container")) {
    import("chartkick").then((module) => {
      window.Chartkick = module.default
    })
  }
})
